import { Inject } from '@angular/core';
import '@angular/compiler';
import { PageAdminReportsComponent } from './page.admin.reports/page.admin.reports.component';
import { PageAdminLoginComponent } from './page.admin.login/page.admin.login.component';
import { LayoutGgeea_adminComponent } from './layout.ggeea_admin/layout.ggeea_admin.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PageAdminChatsComponent } from './page.admin.chats/page.admin.chats.component';
import { PageAdminIndexComponent } from './page.admin.index/page.admin.index.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PageAdminDashboardComponent } from './page.admin.dashboard/page.admin.dashboard.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PageAdminSettingsComponent } from './page.admin.settings/page.admin.settings.component';
import { PageAdminStatsComponent } from './page.admin.stats/page.admin.stats.component';
import { PageRootComponent } from './page.root/page.root.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PageMainComponent } from './page.main/page.main.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, COMPOSITION_BUFFER_MODE } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NuMonacoEditorModule } from '@ng-util/monaco-editor';
import { SortablejsModule } from "src/libs/portal/season/ngx-sortablejs";
import { KeyboardShortcutsModule } from 'ng-keyboard-shortcuts';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
    constructor(@Inject( DomSanitizer) private domSanitizer: DomSanitizer) { }
    transform(url) {
        return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
    }
}

// translate libs
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader'
import { HttpClient, HttpClientModule } from '@angular/common/http';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/lang/', '.json');
}

// initialize ng module
@NgModule({
    declarations: [
        SafePipe,
        AppComponent,
        PageAdminReportsComponent,
        PageAdminLoginComponent,
        LayoutGgeea_adminComponent,
        PortalSeasonPaginationComponent,
        PageAdminChatsComponent,
        PageAdminIndexComponent,
        PortalSeasonTreeComponent,
        PageAdminDashboardComponent,
        PortalSeasonLoadingSeasonComponent,
        PageAdminSettingsComponent,
        PageAdminStatsComponent,
        PageRootComponent,
        PortalSeasonModalComponent,
        PageMainComponent,
        PortalSeasonLoadingDefaultComponent,
        PortalSeasonFormDropdownComponent,
        LayoutEmptyComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        NgbModule,
        SortablejsModule,
        KeyboardShortcutsModule.forRoot(),
        NuMonacoEditorModule.forRoot({ baseUrl: `lib` }),
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            },
            defaultLanguage: 'en'
        }),
        
    ],
    providers: [
        {
            provide: COMPOSITION_BUFFER_MODE,
            useValue: false
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }